import { Column } from "../table.data.interface";
import { parseRawValue } from "./buildColumnValue";

/**
 * Turns a column monday returned from a write into the fields a "Shared Columns" row holds.
 * Mirrors integration-ms `ItemLocationsHelper.getOriginColumnData`, which builds those rows:
 * the display text (or "Empty Column"), a checkbox's boolean, people as ids, a status's index.
 */
export const toSharedColumnPatch = (
  type: string,
  written: { text?: string | null; value?: string | null },
  /** The column's parsed settings, when known: they give a status label its colour. */
  settings?: any,
): Pick<Column, "value"> & Partial<Pick<Column, "label" | "label_style" | "persons_and_teams">> => {
  const raw = parseRawValue(written.value);

  if (type === "checkbox") return { value: raw?.checked };
  if (type === "people") {
    if (!raw?.personsAndTeams) return { value: raw?.personsAndTeams };
    const entries: { id: number; kind: "person" | "team" }[] = raw.personsAndTeams;
    // Ids alone can't tell a user from a team with the same id, so keep the kinds alongside.
    return {
      value: entries.map((entry) => entry.id),
      persons_and_teams: entries.map((entry) => ({ id: entry.id, kind: entry.kind })),
    };
  }

  const value = written.text === "" || written.text == null ? "Empty Column" : written.text;
  if (type === "status") {
    const color = settings?.labels_colors?.[raw?.index]?.color;
    return { value, label: raw?.index, ...(color ? { label_style: { color } } : {}) };
  }
  return { value };
};
